export default __webpack_public_path__ + "static/media/register12.5fcc9262.jpg";